/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  const serviceWorker = navigator.serviceWorker
  const shouldReloadOnUpdate = Boolean(serviceWorker?.controller)
  let isReloading = false

  if (shouldReloadOnUpdate) {
    serviceWorker.addEventListener('controllerchange', () => {
      if (isReloading) return

      isReloading = true
      window.location.reload()
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      document.dispatchEvent(new CustomEvent('sw-updated', { detail: registration }))
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
      document.dispatchEvent(new CustomEvent('sw-offline'))
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
